import { useState } from 'react';
import { Circle } from 'lucide-react';
import { Sheet } from '../../components/ui/Sheet';
import { resolveIcon } from '../../lib/icons';
import { uid, type Attachment } from '../../types';

const OPTIONS = ['image', 'file-text', 'camera', 'sparkles', 'list-checks'];

export function CameraCapture({
  open,
  onClose,
  onCapture,
}: {
  open: boolean;
  onClose: () => void;
  onCapture: (attachment: Attachment) => void;
}) {
  const [symbol, setSymbol] = useState('camera');
  const Preview = resolveIcon(symbol);

  return (
    <Sheet open={open} onClose={onClose} title="Camera">
      <div className="flex flex-col items-center gap-6 py-4">
        <div className="w-full h-72 rounded-3xl bg-black/85 flex flex-col items-center justify-center gap-4">
          <Preview size={84} color="white" strokeWidth={1.8} />
          <span className="text-white/70 text-sm">Camera preview</span>
        </div>
        <div className="flex gap-3">
          {OPTIONS.map((opt) => {
            const Icon = resolveIcon(opt);
            return (
              <button
                key={opt}
                onClick={() => setSymbol(opt)}
                className={`w-11 h-11 rounded-xl border flex items-center justify-center ${
                  symbol === opt ? 'border-blue-500 bg-blue-500/10' : 'border-black/15 dark:border-white/20'
                }`}
              >
                <Icon size={18} />
              </button>
            );
          })}
        </div>
        <button
          onClick={() => {
            onCapture({ id: uid(), symbol, colorHex: '#EF4444', title: symbol });
            onClose();
          }}
          className="text-red-600 hover:opacity-80"
          aria-label="Capture"
        >
          <Circle size={54} strokeWidth={2.5} fill="currentColor" className="text-red-600" />
        </button>
      </div>
    </Sheet>
  );
}
